import { DRAWER_KEY } from 'app-constants/common'
import { URL_FILES } from '../common/envs'
import { FIREBASE_EVENTS } from '../common/events'

export const DOCUMENTS_PAGE_LABELS = [
  {
    name: 'Termos',
    items: [
      {
        urlFile: `${URL_FILES}termo_de_aceite_confirmacao_da_solicitacao_de_portabilidade.pdf`,
        name: 'Termo de Aceite',
        description: 'Confirmação da solicitação de portabilidade',
      },
      {
        urlFile: `${URL_FILES}formulario_transferencia_assinatura.pdf`,
        name: 'Transferência de Assinatura',
        description: 'Formulário de Transferência de Assinatura',
      },
      {
        urlFile: `${URL_FILES}troca-titularidade/TROCA-DE-TITULARIDADE-GIGA.pdf`,
        name: 'Troca de titularidade',
        description: 'Formulário de troca de titularidade',
      },
      {
        name: 'Corrigir pagamento indevido',
        description: 'Formulário para correção de pagamento indevido',
        event: FIREBASE_EVENTS.CLICK_ON_ACCESS_UNDUE_PAYMENT,
        btnLabel: 'Acessar',
        icon: '>',
        drawerKey: DRAWER_KEY.UNDUE_PAYMENT,
      },
    ],
  },
]
